import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.path ? `http://h8wx1.com/${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center gap-2 text-xs text-foreground-400 flex-wrap">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-2">
              {i > 0 && (
                <span className="text-foreground-300">/</span>
              )}
              {item.path && i < items.length - 1 ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {item.name}
                </Link>
              ) : (
                <span className={i === items.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                  {item.name}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}